import { ff } from '@atlassian/jira-feature-flagging';

// <esala>
export const isFetchBacklogChildIssuesDataEnabled = () =>
	ff('sea-2127-backlog-fetch-child-issues-data-tmps_obopa', false);
// </esala>
